module.exports = __webpack_public_path__ + "static/media/move.c4137a93.svg";